module.exports = __webpack_public_path__ + "img/s8-img5.a7dee2bf.png";